module.exports = {
  SLIDE_LIST: [
    {
      slide: 'start',
      newContent: true,
      slug: 'epaper-qualitaeten-2024',
      title: 'E-Paper-Qualitäten 2024',
      thumbnail: '/thumbnails/ZMG_E-Paper-Qualitaeten2024-start.png',
      download: 'ZMG_E-Paper-Qualitaeten2024-start.png',
    },
    {
      slide: 'fast-jeder-dritte-nutzt-epaper',
      newContent: false,
      slug: 'fast-jeder-dritte-nutzt-epaper',
      title: 'Fast jede(r) Dritte nutzt E-Paper',
      thumbnail: '/thumbnails/ZMG_E-Paper-Qualitaeten2024-fast-jeder-dritte-nutzt-epaper.png',
      download: 'ZMG_E-Paper-Qualitaeten2024-fast-jeder-dritte-nutzt-epaper.png',
    },
    {
      slide: 'auch-epaper-werden-geteilt',
      newContent: false,
      slug: 'auch-epaper-werden-geteilt',
      title: 'Auch E-Paper werden geteilt',
      thumbnail: '/thumbnails/ZMG_E-Paper-Qualitaeten2024-auch-epaper-werden-geteilt.png',
      download: 'ZMG_E-Paper-Qualitaeten2024-auch-epaper-werden-geteilt.png',
    },
    {
      slide: 'epaper-werden-intensiv-genutzt',
      newContent: false,
      slug: 'epaper-werden-intensiv-genutzt',
      title: 'E-Paper werden intensiv genutzt',
      thumbnail: '/thumbnails/ZMG_E-Paper-Qualitaeten2024-epaper-werden-intensiv-genutzt.png',
      download: 'ZMG_E-Paper-Qualitaeten2024-epaper-werden-intensiv-genutzt.png',
    },
    {
      slide: 'leser-nutzen-alle-teile-des-epaper',
      newContent: false,
      slug: 'leser-nutzen-alle-teile-des-epaper',
      title: 'Leser nutzen alle Teile des E-Paper',
      thumbnail: '/thumbnails/ZMG_E-Paper-Qualitaeten2024-leser-nutzen-alle-teile-des-epaper.png',
      download: 'ZMG_E-Paper-Qualitaeten2024-leser-nutzen-alle-teile-des-epaper.png',
    },
    {
      slide: 'epaper-sind-eine-regionale-institution',
      newContent: false,
      slug: 'epaper-sind-eine-regionale-institution',
      title: 'E-Paper: eine regionale Institution',
      thumbnail: '/thumbnails/ZMG_E-Paper-Qualitaeten2024-epaper-sind-eine-regionale-institution.png',
      download: 'ZMG_E-Paper-Qualitaeten2024-epaper-sind-eine-regionale-institution.png',
    },
    {
      slide: 'epaper-sind-ueberall-gut-zu-nutzen',
      newContent: false,
      slug: 'epaper-sind-ueberall-gut-zu-nutzen',
      title: 'E-Paper: überall gut zu nutzen',
      thumbnail: '/thumbnails/ZMG_E-Paper-Qualitaeten2024-epaper-sind-ueberall-gut-zu-nutzen.png',
      download: 'ZMG_E-Paper-Qualitaeten2024-epaper-sind-ueberall-gut-zu-nutzen.png',
    },
    {
      slide: 'epaper-sind-jung-und-mobil',
      newContent: false,
      slug: 'epaper-sind-jung-und-mobil',
      title: 'E-Paper: jung und mobil',
      thumbnail: '/thumbnails/ZMG_E-Paper-Qualitaeten2024-epaper-sind-jung-und-mobil.png',
      download: 'ZMG_E-Paper-Qualitaeten2024-epaper-sind-jung-und-mobil.png',
    },
    {
      slide: 'epaper-machen-mobil',
      newContent: false,
      slug: 'epaper-machen-mobil',
      title: 'E-Paper machen mobil',
      thumbnail: '/thumbnails/ZMG_E-Paper-Qualitaeten2024-epaper-machen-mobil.png',
      download: 'ZMG_E-Paper-Qualitaeten2024-epaper-machen-mobil.png',
    },
    {
      slide: 'nutzungsweisen-des-epaper',
      newContent: true,
      slug: 'nutzungsweisen-des-epaper',
      title: 'Nutzungsweisen des E-Paper',
      thumbnail: '/thumbnails/ZMG_E-Paper-Qualitaeten2024-nutzungsweisen-des-epaper.png',
      download: 'ZMG_E-Paper-Qualitaeten2024-nutzungsweisen-des-epaper.png',
    },
    {
      slide: 'anzeigen-im-epaper-sind-relevant',
      newContent: false,
      slug: 'anzeigen-im-epaper-sind-relevant',
      title: 'Anzeigen im E-Paper: wertvoll und relevant',
      thumbnail: '/thumbnails/ZMG_E-Paper-Qualitaeten2024-anzeigen-im-epaper-sind-relevant.png',
      download: 'ZMG_E-Paper-Qualitaeten2024-anzeigen-im-epaper-sind-relevant.png',
    },
    {
      slide: 'epaper-machen-anzeigen-mobil',
      newContent: false,
      slug: 'epaper-machen-anzeigen-mobil',
      title: 'E-Paper machen Anzeigen mobil',
      thumbnail: '/thumbnails/ZMG_E-Paper-Qualitaeten2024-epaper-machen-anzeigen-mobil.png',
      download: 'ZMG_E-Paper-Qualitaeten2024-epaper-machen-anzeigen-mobil.png',
    },
  ],
};
